const signs = [
  'руководитель работает дольше всех сотрудников и регулярно задерживается;',
  'все вопросы идут к руководителю, даже самые простые;',
  'сотрудники ждут указаний и не начинают работу без команды;',
  'руководитель не успевает заниматься стратегическими задачами, потому что загружен операционной работой;',
  'задачи приходится постоянно напоминать — сотрудники не держат их в фокусе;',
  'сотрудники боятся принимать решения самостоятельно;',
  'руководитель регулярно переделывает работу за сотрудниками;',
  'сроки срываются, потому что руководитель не успевает всё проконтролировать;',
  'руководитель стал «узким местом» — без его участия не решается ни один вопрос;',
  'команда не растёт вместе с бизнесом — сотрудники работают так же, как год назад.',
];

export default function WhenManagerNeedsDelegationTraining() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Когда руководителю особенно необходимо обучение делегированию
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-10 max-w-3xl mx-auto leading-relaxed">
          Признаки, что управленческой команде пора развивать навыки делегирования и постановки задач
        </p>

        <div className="grid sm:grid-cols-2 gap-3 mb-10 max-w-4xl mx-auto">
          {signs.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-3">
              <i className="ri-alert-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700">{s}</span>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Обсудить управленческую задачу
            <i className="ri-chat-3-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}